import { merge, of, pipe } from 'rxjs';
import { filter as rxFilter, map as rxMap, share, withLatestFrom } from 'rxjs/operators';
import { metaValidationGroups } from '../../../utils/data';
import { runType } from '../../../validations/constants';
import { getFieldsToValidateFromFormData } from '../../../validations/utils';
import validateFields from '../../../validations/validateFields';
import { actionNames } from '../../transfer/control';
import { updateValidationResultMultiple } from '../../transfer/transmission';
import { bufferControl, filterByActionType } from '../../utils';
import { mapDirtyFieldNames, validateSyncAndAsyncFields } from '../utils';
const createMultipleValidationParams = ([[fieldsToValidate, validationGroups], formData, formDescriptor, formFieldState], reduxStore)=>({
        groups: validationGroups,
        runType: runType.FIELD,
        fieldsToValidate,
        formData,
        formFieldState,
        formDescriptor,
        reduxStore
    });
const validateMultiple = ({ formData$, formDescriptor$, formFieldState$ }, reduxStore)=>pipe(withLatestFrom(formData$, formDescriptor$, formFieldState$), rxMap((value)=>validateFields(createMultipleValidationParams(value, reduxStore))));
export const validateFieldsPromise = (action, formStream$, reduxStore)=>of(action).pipe(rxMap((action)=>[
            action.payload,
            metaValidationGroups(action)
        ]), validateSyncAndAsyncFields(formStream$, reduxStore, createMultipleValidationParams)).toPromise();
const updateValidationResultWithPayload = (payload)=>updateValidationResultMultiple(payload);
export default (({ control$, ...other$ }, reduxStore)=>{
    const action$ = control$.pipe(filterByActionType(actionNames.VALIDATE_FIELDS), rxMap((action)=>[
            action.payload,
            metaValidationGroups(action)
        ]), validateMultiple(other$, reduxStore), rxMap(updateValidationResultWithPayload), share());
    const modifyFormData$ = control$.pipe(filterByActionType(actionNames.DEEP_MERGE_DATA, actionNames.REPLACE_DATA), rxFilter(({ meta })=>meta.validate), withLatestFrom(other$.formDescriptor$), rxMap(([action, formDescriptor])=>[
            getFieldsToValidateFromFormData(formDescriptor, action.payload),
            metaValidationGroups(action)
        ]), // it seems that deep merge is always resolved before this.
    // which means that we no need to wait for next formData emission.
    // otherwise we should check if data has been merged, but it is not necessary for now
    validateMultiple(other$, reduxStore), rxMap(updateValidationResultWithPayload), share());
    const registration$ = control$.pipe(bufferControl(control$, actionNames.REGISTER), rxMap((action)=>[
            mapDirtyFieldNames(action)
        ]), validateMultiple(other$, reduxStore), rxMap(updateValidationResultWithPayload), share());
    return merge(action$, registration$, modifyFormData$);
});
